export default __webpack_public_path__ + "static/media/me.8482cfeb.png";